import { Component } from "react";
import Header from "./HeaderComponent";
import Home from "./HomeComponent";
import Whales from "./WhalesComponent";
import Liquidations from "./LiquidationsComponent";
import Prime from "./PrimeComponent";
import IsolatedLending from "./IsolatedLendingComponent";
import Stables from "./StablesComponent"
import Footer from "./FooterComponents";
import { Routes , Route} from 'react-router-dom';

class Main extends Component {
    render() {
        return (
            <div>
                <Header />
                <Routes>
                    <Route exact path='/' element={<Home/>} />
                    <Route exact path='/whales' element={<Whales/>}  />
                    <Route exact path='/liquidations' element={<Liquidations/>}  />
                    <Route exact path='/prime' element={<Prime/>}  />
                    {/*<Route exact path='/isolatedLending' element={<IsolatedLending/>}  /> */}
                    {/*<Route exact path='/stables' element={<Stables/>}  /> */}
                </Routes>
                <Footer />
            </div>
        )
    }
}

export default Main;
